module.exports = __webpack_public_path__ + "img/code-image.6a7a8c7c.png";